export default "__VITE_ASSET__D8WZiXhd__"